import { IRootState } from '../../../store'
import { IApiErrorHandlerState } from '../store/apiErrorHandler.types'

export const getApiErrorHandlerSelector = (state: IRootState): IApiErrorHandlerState => state.apiErrorHandler
